import script from "./CompanyName+DBA+PC+INV+Category+AcctMgrNotes+DescriptionCell.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyName+DBA+PC+INV+Category+AcctMgrNotes+DescriptionCell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__